export default __webpack_public_path__ + "static/media/pinksale.dfc802fd.png";